import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const InitiateReturnPage = lazy(
  () =>
    import('./InitiateReturnPage.eager').then(mod => ({
      default: mod.InitiateReturnPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
